import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { DOCUMENTOS_OBJETO_E_PE } from '../../shared/certidoesPositivasSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';
import { DEFICIENCIA_OPCOES, DEFICIENCIA_NAO_POSSUI_ID, SEXO_OPCOES } from '../../shared/catalogosPessoaFisica';

const pedidoTransformacaoSuplementarTransferenciaConfig = {
  id: 'pedido_transformacao_suplementar_transferencia',
  nome: 'Transformação da Inscrição Suplementar em Transferência',
  descricao: 'Solicitação de transformação de inscrição suplementar em transferência na OAB/MS',
  icon: 'FaUserTransform',
  categoria: 'inscricao',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento de transformação de inscrição suplementar em transferência preenchido e assinado digitalmente', required: true },
      { id: 'declaracaoAutenticidade', tipoDocumentoProcesso: 492, name: 'Declaração de Autenticidade', description: 'Declaração de autenticidade dos documentos apresentados', required: true },
      { id: 'declaracaoIdoneidade', tipoDocumentoProcesso: 318, name: 'Declaração de Idoneidade', description: 'Declaração de idoneidade (modelo padrão)', required: true },
      { id: 'certidaoEstadualCivel', tipoDocumentoProcesso: 514, name: 'Certidão Estadual 1º Grau Cível de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualCriminal', tipoDocumentoProcesso: 515, name: 'Certidão Estadual 1º Grau Criminal de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualCrimeMilitar', tipoDocumentoProcesso: 516, name: 'Certidão Estadual 1º Grau Crime Militar de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualOrigem', tipoDocumentoProcesso: 526, name: 'Certidão Estadual de 1º Grau Cível, Criminal e Crime Militar – Estado de Origem', description: 'Certidões da comarca/seccional de origem, em arquivo único PDF', required: true },
      { id: 'certidaoFederalCivel', tipoDocumentoProcesso: 520, name: 'Certidão Federal de 1º e 2º Grau Cível do TRF3 – Abrangência Regional', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoFederalCriminal', tipoDocumentoProcesso: 519, name: 'Certidão Federal de 1º e 2º Grau Criminal do TRF3 – Abrangência Regional', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoFederalCivelOrigem', tipoDocumentoProcesso: 527, name: 'Certidão Federal de 1º Grau Cível - Estado de Origem', description: 'Certidão federal cível da região de origem', required: true },
      { id: 'certidaoFederalCriminalOrigem', tipoDocumentoProcesso: 528, name: 'Certidão Federal de 1º Grau Criminal - Estado de Origem', description: 'Certidão federal criminal da região de origem', required: true },
      { id: 'certidaoJusticaFederalMilitar', tipoDocumentoProcesso: 503, name: 'Certidão Justiça Federal Militar (STM)', description: 'Expedida pelo Superior Tribunal Militar (STM). Obrigatória para ambos os sexos.', required: true },
      { id: 'certidaoInteiroTeor', tipoDocumentoProcesso: 376, name: 'Certidão de Inteiro Teor', description: 'Certidão de inteiro teor emitida pela Seccional de origem', required: true },
      { id: 'comprovanteResidencia', tipoDocumentoProcesso: 509, name: 'Comprovante de Residência', description: 'Serão aceitos somente contas de Água e Luz', required: true },
      { id: 'cpf', tipoDocumentoProcesso: 510, name: 'CPF', description: 'Documento do CPF', required: true },
      { id: 'tituloEleitor', tipoDocumentoProcesso: 511, name: 'Título de Eleitor', description: 'Título de Eleitor', required: true }
    ],

    conditional: [
      ...DOCUMENTOS_OBJETO_E_PE,
      {
        id: 'declaracaoResidencia', tipoDocumentoProcesso: 493,
        name: 'Declaração de Residência',
        description: 'Obrigatória quando o endereço residencial informado não estiver em seu nome',
        conditional: true,
        required: true,
        dependsOn: { field: 'enderecoEmSeuNome', value: 'NAO' }
      },
      {
        id: 'cid', tipoDocumentoProcesso: 456,
        name: 'Laudo Médico (CID)',
        description: 'Laudo médico atualizado com CID (obrigatório para PCD)',
        conditional: true,
        required: true,
        dependsOn: { field: 'possuiDeficiencia', notValue: DEFICIENCIA_NAO_POSSUI_ID }
      },
      {
        id: 'atestadoFuncional', tipoDocumentoProcesso: 324,
        name: 'Atestado Funcional',
        description: 'Atestado funcional detalhando atribuições e atividades do cargo (obrigatório para servidores públicos e instituições financeiras)',
        conditional: true,
        required: true,
        dependsOn: { field: 'exerceFuncaoPublica', value: 'SIM' }
      },
      {
        id: 'certidaoCasamento', tipoDocumentoProcesso: 508,
        name: 'Certidão de Casamento',
        description: 'Certidão de casamento atualizada (obrigatória quando houver alteração de nome por casamento)',
        conditional: true,
        required: true,
        dependsOn: [{ field: 'estadoCivil', value: 'Casado' }, { field: 'nomeDifereIdentificacao', value: 'SIM' }]
      },
      {
        id: 'rgOuCin', tipoDocumentoProcesso: 506,
        name: 'RG / CIN',
        description: 'Registro Geral ou Carteira de Identidade Nacional (CIN)',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoDocumentoIdentificacao', value: 'RG_CIN' }
      },
      {
        id: 'cnh', tipoDocumentoProcesso: 507,
        name: 'CNH',
        description: 'Carteira Nacional de Habilitação. Serão aceitas somente emissões a partir de 1º de junho de 2022',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoDocumentoIdentificacao', value: 'CNH' }
      },
      {
        id: 'reservista', tipoDocumentoProcesso: 84,
        name: 'Certificado de Reservista ou Dispensa',
        description: 'Certificado de reservista ou documento de dispensa (obrigatório para homens com menos de 45 anos). Conforme Art. 5º da Lei nº 4.375/1964, maiores de 45 anos são desobrigados.',
        conditional: true,
        required: true
      }
    ]
  },

  paymentConfig: {
    amount: 251.00
  },

  protocoloConfig: {
    modeloRequerimento: '191',
    tiposAssunto: '267',
    tipoPedido: '52'
  },

  // Confirmado ao vivo contra GET /modelo-requerimento/191/campos — só
  // Nome/CPFCNPJ/EmailResidencial + endereço (sem grupo Comercial, apesar do
  // form coletar endereço profissional opcional).
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 70,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'date', name: 'dataNascimento', label: 'Data de Nascimento', required: true },
            { type: 'radio', name: 'sexo', label: 'Sexo', required: true, options: SEXO_OPCOES },
            {
              type: 'select',
              name: 'estadoCivil',
              label: 'Estado Civil',
              required: true,
              options: [
                { value: 'Solteiro', label: 'Solteiro(a)' },
                { value: 'Casado', label: 'Casado(a)' },
                { value: 'Divorciado', label: 'Divorciado(a)' },
                { value: 'Viuvo', label: 'Viúvo(a)' },
                { value: 'UniaoEstavel', label: 'União Estável' }
              ]
            }
          ]
        },
        {
          title: 'Documentos pessoais e eleitorais',
          fields: [
            { type: 'text', name: 'documentoIdentidade', label: 'Documento de Identidade (RG/CIN)', placeholder: 'Nº do RG ou CIN', required: true },
            { type: 'text', name: 'orgaoEmissor', label: 'Órgão Expedidor', placeholder: 'Ex: SSP, DETRAN', required: true },
            { type: 'date', name: 'dataEmissao', label: 'Data Emissão', required: true },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true },
            { type: 'text', name: 'tituloEleitor', label: 'Título de Eleitor', placeholder: 'Nº do título', required: true },
            { type: 'text', name: 'zonaEleitoral', label: 'Zona do Título', placeholder: 'Zona', required: true },
            { type: 'text', name: 'secaoEleitoral', label: 'Seção do Título', placeholder: 'Seção', required: true },
            { type: 'text', name: 'municipioTitulo', label: 'Município do Título', placeholder: 'Cidade do título', required: true },
            {
              type: 'radio',
              name: 'tipoDocumentoIdentificacao',
              label: 'Qual documento de identificação você vai enviar?',
              required: true,
              options: [
                { value: 'RG_CIN', label: 'RG / CIN (Carteira de Identidade Nacional)' },
                { value: 'CNH', label: 'CNH (Carteira Nacional de Habilitação)' }
              ],
              defaultValue: 'RG_CIN'
            },
            {
              type: 'dataEmissaoCNH',
              name: 'dataEmissaoCNH',
              label: 'Data de Emissão da CNH',
              required: true,
              showWhen: { field: 'tipoDocumentoIdentificacao', value: 'CNH' }
            }
          ]
        },
        {
          title: 'Declarações pessoais',
          fields: [
            {
              type: 'select',
              name: 'possuiDeficiencia',
              label: 'Deficiência',
              required: true,
              options: DEFICIENCIA_OPCOES,
              defaultValue: DEFICIENCIA_NAO_POSSUI_ID
            },
            {
              type: 'radio',
              name: 'exerceFuncaoPublica',
              label: 'Exerce função/emprego público?',
              required: true,
              options: [{ value: 'SIM', label: 'Sim' }, { value: 'NAO', label: 'Não' }],
              defaultValue: 'NAO'
            },
            {
              type: 'text',
              name: 'orgaoFuncaoPublica',
              label: 'Órgão / Instituição',
              required: true,
              placeholder: 'Ex: Tribunal de Justiça, Ministério Público, etc.',
              showWhen: { field: 'exerceFuncaoPublica', value: 'SIM' }
            },
            {
              type: 'text',
              name: 'cargoFuncaoPublica',
              label: 'Cargo / Função',
              required: true,
              placeholder: 'Ex: Juiz, Promotor, Analista, etc.',
              showWhen: { field: 'exerceFuncaoPublica', value: 'SIM' }
            },
            {
              type: 'radio',
              name: 'nomeDifereIdentificacao',
              label: 'O nome que consta no seu documento de identificação é diferente do seu nome atual (nome de solteiro(a))?',
              showWhen: { field: 'estadoCivil', value: 'Casado' },
              required: true,
              options: [
                { value: 'SIM', label: 'Sim, meu nome atual é diferente do nome no documento' },
                { value: 'NAO', label: 'Não, meu nome é o mesmo' }
              ],
              defaultValue: 'NAO'
            }
          ]
        }
      ]
    },
    enderecoStep({ comProfissional: true, autoCep: true }),
    termosStep(['validadeCertidoes', 'assinaturaDigitalComIdoneidade'], { certidoesPositivas: true })
  ]
};

export default pedidoTransformacaoSuplementarTransferenciaConfig;
